"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SceneChild = void 0;
/**
 * Autoincrement sceneChild default id
 *
 * @internal
 * @ignore
 */
let __id = 0;
/**
 * The element to be added into a scene.
 * Preserve props, drawing order, generate and return buffers.
 * The only implementations of this class are <a href="[base_url]/Group">Group</a> and <a href="[base_url]/ShapeBase">ShapeBase</a>
 *
 * @abstract
 * @category Scene
 * @order 2
 * @class SceneChild
 */
class SceneChild {
    /**
     * Creates an instance of SceneChild.
     * Base values will be assigned in case they are not passed
     *
     * @param {ISceneChildSettings} settings
     */
    constructor(settings) {
        var _a;
        /**
         * Shape generation id
         * used for prevent buffer calculation
         *
         * @internal
         * @ignore
         */
        this.generateId = -1;
        this.id = (_a = settings.id) !== null && _a !== void 0 ? _a : ++__id;
        this.type = settings.type || 'SceneChild';
        this.name = settings.name || this.type + '_' + this.id;
        this.data = settings.data || {};
        this.props = {};
    }
    /**
     * Find this or form or children.
     * Overridden by classes that extend it
     *
     * @param {string | number} idOrName
     * @returns {(SceneChild | null)}
     */
    find(idOrName) {
        if (this.id === idOrName || this.name === idOrName)
            return this;
        return null;
    }
    /**
     * Return the sceneChild properties
     *
     * @returns {Props}
     */
    getProps() {
        return this.props;
    }
    /**
     * Return a sceneChild prop or default value
     *
     * @param {keyof Props} key
     * @param {PropArguments} [propArguments]
     * @param {*} [defaultValue]
     * @returns {*}
     */
    getProp(key, propArguments, defaultValue) {
        var _a;
        return ((_a = this.props[key]) !== null && _a !== void 0 ? _a : defaultValue);
    }
    /**
     * Check SceneChild has prop
     *
     * @param {keyof Props} key
     * @returns
     */
    hasProp(key) {
        return typeof this.props[key] !== 'undefined';
    }
    /**
     * Set a single or multiple props
     *
     * @param {(keyof ISceneChildProps<PropArguments> | ISceneChildProps<PropArguments>)} key
     * @param {*} [value]
     */
    setPropUnsafe(key, value) {
        if (typeof key == 'string')
            this.props[key] = value;
        else
            Object.keys(key).forEach((k) => (this.props[k] = key[k]));
    }
}
exports.SceneChild = SceneChild;
//# sourceMappingURL=SceneChild.js.map